import Url from 'url-parse'

const DefaultOrigin = globalThis.location?.origin ?? 'https://example.com'

export function createURL(
  url: string = '/',
  params: Record<string, any> = {},
  absolute = false,
  basename = ''
) {
  const newUrl = new Url(url, {}, true)
  newUrl.set('query', { ...newUrl.query, ...params })
  if (newUrl.slashes) {
    return new URL(newUrl.toString(), DefaultOrigin).href
  }
  if (absolute)
    return withBaseName(
      new URL(newUrl.toString(), DefaultOrigin).href,
      basename
    )
  return newUrl.toString()
}

export function withBaseName(url: string, basename: string) {
  if (!basename) return url
  const newUrl = new Url(url, {})
  newUrl.set('pathname', `${basename}${newUrl.pathname}`)
  return newUrl.toString()
}
